import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import "./style.scss";
import { Link } from "react-router-dom";
import AuthLayout from "../../components/AuthLayout";
import { toast } from "react-toastify";
import { MdEmail } from "react-icons/md";

const Forgotpassword = () => {
  const history = useNavigate();
  const [form, setForm] = useState({ email: "" });

  useEffect(() => {
    if (localStorage.getItem("token")) {
      history("/dashboard");
    }
  }, []);

  const hendleSubmit = (e: any) => {
    e.preventDefault();
    loader(true);
    ApiClient.post("user/admin/forgot/password", form).then((res) => {
      if (res.success) {
        history("/login");
        setTimeout(() => {
          toast.success(res.message);
        }, 100);
      }
      loader(false);
    });
  };

  return (
    <>
      <AuthLayout>
          <div className="auth-page grid lg:grid-cols-2 grid-cols-1 gap-3 max-w-[1100px] w-full rounded-[20px] bg-[#FFFFFF1A] sm:p-7 p-5 mx-auto">
            <div className="w-[400px] lg:block hidden ">
              <img
                src="/img/auth-main.webp"
                className="rounded-[20px] max-h-[520px] "
              />
            </div>
            <div className="w-[360px] max-w-full m-auto">
              <form className="" onSubmit={hendleSubmit}>
                <div className="relative  mb-4 ">
                  <img
                    src="/img/logo.png"
                    className=" mx-auto max-w-[170px] object-contain"
                    alt="login-image"
                  />
                </div>

                <div className="mb-8">
                  <h3 className="xl:text-[24px] lg:text-[22px] sm:text-[20px] text-[18px] font-semibold text-[#fff] text-center">
                    Forgot Password
                  </h3>
                  <p className="text-[12px] sm:text-[14px] font-normal text-[#BCBCBC] text-center mt-2">
                    No worries! Just enter your email and we’ll send you a reset
                    password link.
                  </p>
                </div>

                <div className="relative flex items-center">
                  <input
                    name="email"
                    type="email"
                    value={form.email}
                    pattern="^[^\s@]+@[^\s@]+\.[^\s@]{2,}$"
    onInvalid={(e:any) => e.target.setCustomValidity("Please enter a valid email (example: ex@example.com)")}
    onInput={(e:any) => e.target.setCustomValidity("")}
                    required
                    onChange={(e) =>
                      setForm({ ...form, email: e.target.value })
                    }
                    className="w-full text-[#fff] text-sm bg-[#FFFFFF2B] rounded-[10px] outline-none px-3 pr-10 py-3"
                    placeholder="Enter email"
                  />
                </div>

                <div className="mt-8">
                  <button
                    type="submit"
                    className="w-full py-2.5 px-4 text-sm font-semibold tracking-wider rounded-full text-white !bg-[#CC9900] hover:opacity-80 focus:outline-none"
                  >
                    Send Recovery Email
                  </button>

                  <p className="text-[#FFF] text-center font-normal text-[14px] mt-6">
                    {" "}
                    Just Remember?
                    <Link
                      className="text-[#CC9900] text-[14px] hover:underline !font-semibold"
                      to="/login"
                    >
                      {" "}
                      Sign In
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
      </AuthLayout>
    </>
  );
};

export default Forgotpassword;
